module.exports = __webpack_public_path__ + "static/postgres-ea92d6580dda0fbcf61a8ccb16e0d02a.png";